import React, { useState } from 'react';
import { useCart } from './CartContext';
import { useNavigate } from 'react-router-dom';
import './AutoStorePage.css';

const CheckoutPage = () => {
  const { cart, clearCart } = useCart();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      clearCart();
      setLoading(false);
      navigate('/thank-you');
    }, 1000);
  };

  return (
    <main className="auto-store-main">
      <section className="auto-store-hero">
        <h1>Checkout</h1>
      </section>
      <section className="auto-products-section">
        <form className="auto-checkout-form" onSubmit={handleSubmit} style={{maxWidth: 400, margin: '0 auto'}}>
          <label>Name
            <input type="text" required placeholder="Your Name" />
          </label>
          <label>Email
            <input type="email" required placeholder="Your Email" />
          </label>
          <label>Shipping Address
            <input type="text" required placeholder="Address" />
          </label>
          <button type="submit" className="auto-place-order" disabled={loading}>
            {loading ? 'Placing Order...' : 'Place Order'}
          </button>
        </form>
      </section>
    </main>
  );
};

export default CheckoutPage; 